<app-tabla
  [totalCount]="totalCount"
  [datos]="logs"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [emptyState]="{ title: 'Todavía no hay logs de trackeo' }"
></app-tabla>
